import { Injectable } from '@angular/core';
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { Capacitor } from '@capacitor/core';

@Injectable({
    providedIn: 'root'
})
export class LocalDataService {
    public dataDirPath: string = "begaymFiles";
    public data: any = {};

    readFileFromWebUrl(url:string, fileName: string) {
        return new Promise<any>(async (resolve, reject) => {
            if(Capacitor.getPlatform() !== 'web') {
                Filesystem.stat({
                    path: this.dataDirPath + "/" + fileName,
                    directory: Directory.Data
                }).then(()=>{
                    Filesystem.readFile({
                        path: this.dataDirPath + '/' + fileName,
                        directory: Directory.Data,
                        encoding: Encoding.UTF8,
                    }).then((readResult:any)=>{
                        resolve(JSON.parse(readResult.data));
                    }, async (error) =>{
                        const response = await fetch(url);
                        const blob = await response.blob();
                        const reader = new FileReader();
    
                        reader.readAsDataURL(blob);
                        reader.onloadend = async () => {
                            const base64data = reader.result?.toString().split(',')[1];
    
                            if (base64data) {
                                this.writeFile(fileName, base64data).then(()=>{
                                    this.readFile(fileName).then((data:any)=>{
                                        resolve(data);
                                    });
                                }, (error)=>{
                                    reject(error);
                                });
                            }else{
                                reject();
                            };
                        };
                    });
                });
            }else{
                window.open(url, '_blank')
            };
        });
    }

    creatDataDirPath() {
        return new Promise<void>((resolve, reject) => {
            if(Capacitor.getPlatform() !== 'web') {
                Filesystem.stat({
                    path: this.dataDirPath,
                    directory: Directory.Data
                }).then(()=>{resolve()}, (error)=>{
                    Filesystem.mkdir({
                        path: this.dataDirPath,
                        directory: Directory.Data
                    }).then(()=>{
                        resolve();
                    }, (error)=>{
                        reject("cant create dataDir: "+error);
                    });
                });
            }else{
                resolve();
            };
        });
    }
    
    writeFile = (fileName: string, data: string) => {
        return new Promise<void>((resolve, reject) => {
            if(Capacitor.getPlatform() !== 'web') {
                Filesystem.writeFile({
                    path: this.dataDirPath + '/' + fileName,
                    data: data,
                    directory: Directory.Data,
                    encoding: Encoding.UTF8,
                }).then((result:any)=>{
                    resolve();
                }, (error)=>{
                    reject(error);
                });
            }else{
                this.data[fileName] = data;
                resolve();
            };
        });
    };
    
    readFile = (fileName: string) => {
        return new Promise<any>((resolve, reject) => {
            if(Capacitor.getPlatform() !== 'web') {
                Filesystem.stat({
                    path: this.dataDirPath + "/" + fileName,
                    directory: Directory.Data
                }).then(()=>{
                    Filesystem.readFile({
                        path: this.dataDirPath + '/' + fileName,
                        directory: Directory.Data,
                        encoding: Encoding.UTF8,
                    }).then((readResult:any)=>{
                        resolve(JSON.parse(readResult.data));
                    }, (error)=>{
                        reject(error);
                    });
                }, (error)=>{
                    resolve(undefined);
                });
            }else{
                if(this.data.hasOwnProperty(fileName)){
                    resolve(this.data[fileName]);
                }else{
                    resolve(undefined);
                };
            };
        });
    };

    deleteFile = async (fileName: string) => {
        return new Promise<void>((resolve, reject) => {
            if(Capacitor.getPlatform() !== 'web') {
                Filesystem.stat({
                    path: this.dataDirPath + "/" + fileName,
                    directory: Directory.Data
                }).then(()=>{
                    Filesystem.deleteFile({
                      path: this.dataDirPath + "/" + fileName,
                      directory: Directory.Data,
                    }).then(()=>{resolve()}, ()=>{resolve()});
                }, (error)=>{
                    resolve();
                });
            }else{
                localStorage.removeItem(fileName);
                resolve();
            };
        });
    };
}